import axiosInstance from './api';
import { normalizeWhatsAppCommunityLink } from '../utils/whatsappCommunityLink';

const getApiErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  return error.message || error?.error?.message || error?.data?.message || fallback;
};

/**
 * POST /admin/partner/company-info
 * multipart/form-data: logo, coverBanner, text fields, socialLinks (JSON string).
 */
export const updatePartnerCompanyInfo = async (formData) => {
  try {
    const response = await axiosInstance.post('/admin/partner/company-info', formData);
    const payload = response.data;

    return {
      success: true,
      data: payload?.data,
      partnerProfile: payload?.data?.partnerProfile ?? null,
      message: payload?.message || 'Partner company info updated successfully',
    };
  } catch (error) {
    return {
      success: false,
      message: getApiErrorMessage(error, 'Failed to update company info'),
      error,
    };
  }
};

export const buildPartnerCompanyInfoFormData = (form) => {
  const formData = new FormData();

  formData.append('fullName', form.fullName.trim());
  formData.append('shortDescription', form.shortDescription.trim());
  formData.append('description', form.description.trim());

  const socialLinks = {};
  const website = form.websiteUrl?.trim();
  const instagram = form.instagramUrl?.trim();
  const facebook = form.facebookUrl?.trim();
  const whatsappCommunityLink = normalizeWhatsAppCommunityLink(form.whatsappUrl);
  if (website) socialLinks.website = website;
  if (instagram) socialLinks.instagram = instagram;
  if (facebook) socialLinks.facebook = facebook;
  formData.append('socialLinks', JSON.stringify(socialLinks));
  formData.append('whatsappCommunityLink', whatsappCommunityLink);

  if (form.logoFile) {
    formData.append('logo', form.logoFile);
  }
  if (form.coverFile) {
    formData.append('coverBanner', form.coverFile);
  }

  return formData;
};

/** Merge API partnerProfile into the session user used across the partner portal. */
export const mergePartnerProfileWithCompanyInfo = (user, companyProfile) => {
  if (!user || !companyProfile) return user;

  return {
    ...user,
    fullName: companyProfile.fullName ?? user.fullName,
    shortDescription: companyProfile.shortDescription ?? user.shortDescription,
    description: companyProfile.description ?? user.description,
    avatarUrl: companyProfile.avatarUrl ?? user.avatarUrl ?? null,
    coverBannerUrl: companyProfile.coverBannerUrl ?? user.coverBannerUrl ?? null,
    socialLinks: companyProfile.socialLinks ?? user.socialLinks,
    whatsappCommunityLink: normalizeWhatsAppCommunityLink(
      companyProfile.whatsappCommunityLink ?? user.whatsappCommunityLink ?? '',
    ),
  };
};
